import React, {useCallback} from 'react';

import {useDice} from '../../../dice';

import css from '../../../dice/dice.module.css';

type Props = {
	args: string[];
	name: string;
};

// {@dice 1d6 + 3, 6 (1d6 + 3)}
export const DicePlugin: React.FC<Props> = ({args}) => {
	const [formula, text] = args;
	const {roll} = useDice();

	const handleClick = useCallback(
		(e: React.MouseEvent) => {
			e.preventDefault();
			roll(formula, text || formula);
		},
		[formula, text, roll],
	);

	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				roll(formula, text || formula);
			}
		},
		[formula, text, roll],
	);

	return (
		<span
			className={css.dicePlugin}
			role="button"
			tabIndex={0}
			onClick={handleClick}
			onKeyDown={handleKeyDown}
			title={`Бросить ${formula}`}
			aria-label={`Бросить кубики: ${formula}`}
		>
			{text || formula}
		</span>
	);
};
